module.exports = [
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Tezgah Üzeri termostatik duş sistemi. Krom, çevre dostu ve Almanya\\'da üretilmiş 360 mm tepe duşu ve GROHE TrioMassage sprey ve iki spreyli 115 mm el duşu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Tepe duşu seti 450 mm, 2 akışlı",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "GROHE Rainshower 360 DUO -- tepe duşu seti. Krom, Almanya\\'da üretilmiştir: 360 mm tepe duşu ve GROHE TrioMassage sprey ve 450 mm duş kolu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duvara monte tek kumandalı bataryalı duş sistemi",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Tek kumandalı bataryaya sahip GROHE Euphoria Cube XXL Duş sistemi, krom kaplama, Alman mühendisliği ürünü, 230 mm metal tepe duşu ve tek spreyli el duşu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Askılı duş çıkış dirseği",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Eurocube Duş su çıkış dirseği ve duş askısı, krom kaplama ve Alman mühendisliği.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl duş termostatı, ankastre montaj ve tek valf. Yuvarlak şekil, krom kaplama, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, iki valfli ankastre montaja uygun. Yuvarlak şekil, krom kaplama, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik <br />duş bataryası, entegre duş kolu ile",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, ankastre montaja uygun, iki valfli ve entegre duş bağlantılı. Yuvarlak şekil, krom kaplama, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, üç valfli ankastre montaja uygun. Yuvarlak şekil, krom kaplama, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Geri tepme koruma kombinasyonu",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü termostatik duş bataryası, açık/gizli valf",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi üç valfli duş termostatı. Beyaz duş tekneli krom, Alman mühendisliği ürünü.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Açık/gizli valfli batarya için iç gövde",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Duvardan duş  seti 4+ akışlı",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Termostatlı GROHE Euphoria XXL Duş sistemi, krom kaplama, Alman mühendisliği ürünü, 310 mm metal tepe duşu ve su tasarrufu sağlayan 110 mm üç spreyli el duşu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 termostatik duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl duş termostatı, ankastre montaj ve tek valf. Kare şekilinde, krom kaplamalı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, iki valfli ankastre montaja uygun. Kare şekilinde, krom kaplamalı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik <br />duş bataryası, entegre duş kolu ile",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, ankastre montaja uygun, iki valfli ve entegre duş bağlantılı. Kare şekilinde, krom kaplamalı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, üç valfli ankastre montaja uygun. Kare şekilinde, krom kaplamalı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl duş termostatı, ankastre montaj ve tek valf. Kare şekil, Ay Beyazı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, iki valfli ankastre montaja uygun. Kare şekil, Ay Beyazı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, üç valfli ankastre montaja uygun. Kare şekil, Ay Beyazı, GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Termostatik yarı ankastre duş bataryası",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Termostatlı GROHE Rainshower SmartControl 360 DUO Combi duş sistemi. Krom, çevre dostu, Almanya\\'da üretilmiştir: 360 mm tepe duşu ve GROHE TrioMassage sprey ve iki spreyli 115 mm el duşu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Termostatik yarı ankastre duş bataryası",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "Termostatlı GROHE Rainshower SmartControl 360 DUO Combi duş sistemi. Krom, çevre dostu, Almanya\\'da üretilmiştir: 360 mm tepe duşu (beyaz sprey plakası) ve GROHE TrioMassage sprey ve iki spreyli 115 mm el duşu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Tepe duşu seti 450 mm, 2 akışlı",
		"textblock_1st_text": "26254LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 DUO tepe duşu seti. Krom, Almanya\\'da üretilmiştir: 360 mm tepe duşu (beyaz sprey plakası) ve GROHE TrioMassage sprey ve 450 mm duş kolu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "Tempesta Sistem 200",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "27389001",
		"textblock_2nd_text": "GROHE New Tempesta 200 FLEX Yön değiştiricili Duş Sistemi, kolay monte edilmesi için tüm valflerle uyumludur. 200 m iki sprey başlıklı tepe duşu ve 100 mm dört spreyli el duşuyla Almanya\\'da üretilmiştir.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "Tempesta Cosmopolitan Sistem 200",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "Tempesta Sistem 200",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Duvara monte tek kumandalı bataryalı duş sistemi",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 tek kumandalı bataryalı Duş Sistemi, 210 mm tepe duşu ve 100 mm iki spreyli el duşu, krom kaplamalı. Montajı ve temizlenmesi kolay. Alman mühendisliği ürünü",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Tepe duşu seti 430 mm, 2 akışlı",
		"textblock_1st_text": "26475000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive tepe duşu seti ve 2 sprey seçeneği. 400 mm duş kolu olan 310 mm duvara montaj duş başlığı, krom kaplama, yuvarlak şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Tepe duşu seti 430 mm, 2 akışlı",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive tepe duşu seti ve 2 sprey seçeneği. 400 mm duş kolu olan 310 mm duvara monte duş başlığı, krom kaplama ve beyaz sprey plakası, yuvarlak şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive tepe duşu seti ve 2 sprey seçeneği. 142 mm duş kolu olan 310 mm tavana montaj duş başlığı, krom kaplama, yuvarlak şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive tepe duşu seti ve 2 sprey seçeneği. 142 mm duş kolu olan 310 mm tavana montaj duş başlığı, krom kaplama ve beyaz sprey plakası, yuvarlak şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Tepe duşu seti 430 mm, 2 akışlı",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE tepe duşu seti ve 2 sprey seçeneği. 400 mm duş kolu olan 310 mm duvara monte duş başlığı, krom kaplama ve beyaz sprey plakası, kare şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE tepe duşu seti ve 2 sprey seçeneği. 142 mm duş kolu olan 310 mm tavana montaj duş başlığı, krom kaplama, kare şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 termostatlı duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Çıkış ucu",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Çıkış ucu",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Çıkış ucu",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill küvet tropleni",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "El duşu askısı",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "El duşu, 4+ akışlı, gece grisi sprey plakası",
		"textblock_1st_text": "27673000",
		"textblock_2nd_text": "GROHE Power&Soul el duşu, 130 mm, 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "El duşu 1 akışlı",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "GROHE Euphoria Cube Stick, el duşu, 1 akış",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Askılı duş çıkış dirseği",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Tepe duşu 1 akışlı",
		"textblock_1st_text": "27705000",
		"textblock_2nd_text": "GROHE Euphoria Cube 150 head shower with Rain Spray Chrome finish, Made in Germany, with water saving feature",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Twistfree duş hortumu 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silver Flex hortum, TwistFree fonksiyonu için döner bağlantı parçası, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Twistfree duş hortumu 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silver Flex hortum, TwistFree fonksiyonu için döner bağlantı parçası, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 termostatik duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "El duşu askısı",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Askılı duş ��ıkış dirseği",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte yön değiştiricili duş sistemi",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 yön değiştiricili duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Yan duş",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Sürgülü duş seti",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Termostatik bataryalı ve yan jetli duş sistemi",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 termostatlı ve vücut jetli duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "El duşu 1 akışlı",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria Sistem 180",
		"subheadline": "Duvara monte yön değiştiricili duş sistemi",
		"textblock_1st_text": "27421001",
		"textblock_2nd_text": "GROHE Euphoria 180 duş sistemi ve yön değiştirici, GROHE EcoJoy 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 termostatik duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Twistfree duş hortumu 1250<br />",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silver Flex hortum ve TwistFree fonksiyonu için döner konektör, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 termostatlı duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sürgülü duş seti 4+ akışlı",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan seti: el duşu (130 mm), sürgü (900 mm) ve duş hortumu (1.750 mm), 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sürgülü duş seti 4+ akışlı",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul seti: el duşu (160 mm), sürgü (900 mm) ve duş hortumu (1.750 mm), 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sürgülü duş seti 4+ akışlı",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul seti: el duşu (130 mm), sürgü (900 mm) ve duş hortumu (1.750 mm), 9,5 l/dk",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Termostatik duş bataryası / duş seti dahil",
		"textblock_1st_text": "34195001",
		"textblock_2nd_text": "Grohtherm 2000 shower thermostat with GROHE Euphoria shower rail set (consisting of 110mm hand shower with three spray options, 600 mm rail, 1750mm hose and tray)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Tek akışlı tepe duşu seti 286 mm",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Tepe duşu seti 380 mm, tek akışlı",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Tepe duşu seti 380 mm, tek akışlı",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Talentofill küvet tropleni",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Duş sürgüsü, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal giriş kutusu, 1/2",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 termostatik duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Duvardan duş  seti 4+ akışlı",
		"textblock_1st_text": "27741000",
		"textblock_2nd_text": "El duşu (115 mm), duş hortumu (1.250 mm) ve el duşu askılı GROHE Power&Soul Cosmopolitan seti",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Duş sürgüsü, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Duvara monte termostatik banyo bataryalı duş sistemi",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 termostatikve banyo bataryası çıkış uçlu duş sistemi",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Sürgülü duş seti",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "El duşu 1 akışlı",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Tek valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl duş termostatı, ankastre montaj ve tek valf. Yuvarlak şekil, Ay Beyazı GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Çift valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, iki valfli ankastre montaja uygun. Yuvarlak şekil, Ay Beyazı GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Üç valfli akış kontrollü, ankastre termostatik duş bataryası",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl duş ve banyo termostatı, üç valfli ankastre montaja uygun. Yuvarlak şekil, Ay Beyazı GROHE tarafından Almanya\\'da üretilmiştir. Çevre dostu, güvenlik özellikleri mevcut",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox iç gövde",
		"subheadline": "Universal giriş kutusu, 1/2",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260 termostatikDuş Sistemi, 260 mm 3 sprey başlıklı tepe duşu ve 110 mm 3 sprey başlıklı el duşu, krom kaplamalı. Montajı ve temizlenmesi kolay. Alman mühendisliği ürünü",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 termostatikDuş Sistemi, su tasarrufu yapan SmartControl, 260 mm 3 sprey başlıklı tepe duşu ve 110 mm 3 spreyli el duşu, krom kaplamalı. Montajı ve temizlenmesi kolay. Alman mühendisliği ürünü",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte termostatik banyo bataryalı duş sistemi",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 küvetler için termostatikBanyo/Duş Sistemi, su tasarrufu yapan SmartControl, 260 mm 3 sprey başlıklı tepe duşu ve 110 mm 3 spreyli el duşu, krom kaplamalı. Alman mühendisliği ürünü",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Tepe duşu için iç gövde",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Tepe duşu seti 142 mm, tek akışlı&#160;<br /><br type=\"_moz\" />",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, head shower set, ceiling shower arm 142 mm, 9.5 L / min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Tek akışlı tepe duşu seti 286 mm",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Duvara monte termostatik bataryalı duş sistemi",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Tezgah Üzeri termostatik duş sistemi. Krom, çevre dostu ve Almanya\\'da üretilmiş 360 mm tepe duşu (beyaz sprey plakası) ve GROHE TrioMassage sprey ve iki spreyli 115 mm el duşu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Tepe duşu seti 380 mm, 3 akışlı",
		"textblock_1st_text": "26459000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl tepe duşu seti ve üç sprey alanı. Krom kaplamalı su tasarrufu yapan 260 mm duş başlığı ve GROHE Rainshower 380 mm kol. Montajı ve temizlenmesi kolay. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Tepe duşu seti 142 mm, 2 akışlı",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE tepe duşu seti ve 2 sprey seçeneği. 142 mm duş kolu olan 310 mm tavana montaj duş başlığı, krom kaplama ve beyaz sprey plakası, kare şekil. Almanya\\'da üretilmiştir",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Duvara monte tek kumandalı bataryalı duş sistemi",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 tek kumandalı bataryalı Duş Sistemi, su tasarrufu yapan SmartControl, 260 mm 3 sprey başlıklı tepe duşu ve 110 mm 3 spreyli el duşu, krom kaplamalı. Alman mühendisliği ürünü",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "El duşu 2 akışlı",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Duvar bağlantılı, divertörlü duş sistemi",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "GROHE New Tempesta 210 FLEX Shower System with diverter; compatible with all existing valves for easy upgrades. Made in Germany with 210m two-spray head shower and 100mm hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Tepe duşu seti 142 mm, tek akışlı&#160;<br /><br type=\"_moz\" />",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Tavan çıkışlı tek akışlı tepe duşu 154 mm<br /><br type=\"_moz\" />",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Tek akışlı tepe duşu seti 286 mm",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Rainshower SmartActive 310 Cube duş seti",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Shower set with thermostat, for concealed installation with three valves, head shower, hand shower, shower arm, hose. Square shape. Chrome finish, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/nerede-bulur-alirim/grohe-bayisi-bul.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_tr_tr.json
// module id = 841
// module chunks = 0